module.exports = __webpack_public_path__ + "img/help-image-es.d29de9d7.png";